
import React from 'react';
import { ProgressBar } from './progress/ProgressBar';
import { ConvertButton } from './progress/ConvertButton';
import { ConversionStage, ConversionMode } from '@/hooks/conversion/useConversionState';
import { DonationButton } from './DonationButton';
import { ConversionRating } from './rating/ConversionRating';
import { ConversionRatingContext } from '@/hooks/useConversionRating';
import { useTranslation } from 'react-i18next';

interface ConversionProgressProps {
  isConverting: boolean;
  progress: number;
  onConvert: () => void;
  isProcessingComplete?: boolean;
  onDownload?: () => void;
  onNewProcess?: () => void;
  onPrint?: () => void;
  currentLabel?: number;
  totalLabels?: number;
  stage?: ConversionStage;
  conversionMode?: ConversionMode;
  showRating?: boolean;
  ratingContext?: ConversionRatingContext;
  onDismissRating?: () => void;
}

export const ConversionProgress = ({ 
  isConverting, 
  progress, 
  onConvert,
  isProcessingComplete = false,
  onDownload,
  onNewProcess,
  onPrint,
  currentLabel = 0,
  totalLabels = 0,
  stage = 'converting',
  conversionMode = 'standard',
  showRating = false,
  ratingContext,
  onDismissRating
}: ConversionProgressProps) => {

  const { t } = useTranslation();
  
  const handleButtonClick = () => {
    if (isProcessingComplete && onDownload) {
      onDownload();
    } else {
      onConvert();
    }
  };

  const handleProcessAgain = () => {
    onConvert();
  };
  
  return (
    <div className="space-y-4">
      <ProgressBar 
        isConverting={isConverting} 
        progress={progress}
        currentLabel={currentLabel}
        totalLabels={totalLabels}
        stage={stage}
        conversionMode={conversionMode}
      />
      
      <div className="flex justify-center">
        <ConvertButton 
          isConverting={isConverting}
          isProcessingComplete={isProcessingComplete}
          onClick={handleButtonClick}
          onProcessAgain={isProcessingComplete ? handleProcessAgain : undefined}
          onNewProcess={isProcessingComplete ? onNewProcess : undefined}
          onPrint={isProcessingComplete ? onPrint : undefined}
        />
      </div>

      {isProcessingComplete && showRating && (
        <div className="pt-4 border-t border-border/50">
          <ConversionRating context={ratingContext ?? {}} onDismiss={onDismissRating} />
        </div>
      )}

      {isProcessingComplete && !showRating && (
        <div className="pt-4 border-t border-border/50">
          <div className="text-center space-y-2">
            <p className="text-sm text-muted-foreground">{t('likedIt')}</p>
            <DonationButton variant="success" />
          </div>
        </div>
      )}

    </div>
  );
}
